import React from 'react';
import { Col, Row } from '@yme/atoms/grid';
import { useWindowSize } from '@yme/hooks/index';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { BodyTextStyledClamp, HeadingLevel1Clamp, SubtitleStyled } from './styled';
export function HeroInfo({ labels }) {
    const { isMobileView } = useWindowSize();
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { lg: 6, md: 8 },
                React.createElement(SubtitleStyled, { color: colorCoreWhite1000 }, labels.subtitle),
                React.createElement(HeadingLevel1Clamp, { color: colorCoreWhite1000 }, labels.title))),
        !isMobileView && labels?.description && (React.createElement(Row, null,
            React.createElement(Col, { lg: 6, md: 8 },
                React.createElement(BodyTextStyledClamp, null, labels.description))))));
}
HeroInfo.displayName = 'HeroInfo_Component';
